import React from "react";
import "../Styles/greetings.css";

const Greetings = () => {
  return (
    <div className="main-container">
      <div className="container">
        <div className="emoji">🚑</div>
        <h1>Welcome to Our Emergency Health System</h1>
        <p>
          <span className="highlight">Help is on the way!</span> We're cooking
          up something extraordinary to revolutionize emergency healthcare.
        </p>
        <p>
          Our platform is designed to connect you with life-saving services
          faster than ever, ensuring peace of mind when it matters most.
        </p>
        <p>
          Stay tuned for a seamless, user-friendly experience that puts your
          health first.{" "}
          <span className="highlight">Coming soon to save the day!</span>
        </p>
      </div>
    </div>
  );
};

export default Greetings;
